import { getMyAccountPath, getPublicWebsiteUrl } from "@/lib/websiteUrls"

const PUBLIC_WEBSITE_URL = getPublicWebsiteUrl()
const LEGACY_MYACCOUNT_URL = getMyAccountPath()
const TYPEFORM_URL = "https://soenergy.typeform.com"
const WHAT_3_WORDS_URL = "https://what3words.com"

const helpRoutes = {
  getSupport: `${PUBLIC_WEBSITE_URL}support/home`,
  energySaving: `${PUBLIC_WEBSITE_URL}energy/saving`,
  unhappy: `${PUBLIC_WEBSITE_URL}help/unhappy`,
  emergency: `${PUBLIC_WEBSITE_URL}help/emergency`,
  priceCap: `${PUBLIC_WEBSITE_URL}energy/price-cap`,
  troubleshooting: `${PUBLIC_WEBSITE_URL}troubleshooting-ihd`,
  contactUs: `${LEGACY_MYACCOUNT_URL}contact-us`,
  energyUsage: `${PUBLIC_WEBSITE_URL}support/solutions/articles/7000093578-get-to-know-your-energy-usage`,
} as const

const productRoutes = {
  solar: `${PUBLIC_WEBSITE_URL}solar/quote`,
  homeCover: `${PUBLIC_WEBSITE_URL}heating/so-home-cover`,
  heatPumps: `${PUBLIC_WEBSITE_URL}heating/so-heat-pumps`,
  smartMeters: `${PUBLIC_WEBSITE_URL}energy/smart-meters`,
} as const

const aboutUsRouters = {
  quote: `${PUBLIC_WEBSITE_URL}quote`,
  aboutUs: `${PUBLIC_WEBSITE_URL}about-us`,
  reviews: `${PUBLIC_WEBSITE_URL}about-us/reviews`,
  news: `${PUBLIC_WEBSITE_URL}news`,
  careers: `https://careers.so.energy`,
  ourEnergy: `${PUBLIC_WEBSITE_URL}our-energy`,
} as const

export const ExternalRoute = {
  // LEGACY WEBSITE URLS
  tariff: `${LEGACY_MYACCOUNT_URL}tariff`,
  usage: `${LEGACY_MYACCOUNT_URL}usage`,
  billsAndStatements: `${LEGACY_MYACCOUNT_URL}balance`,
  referAFriend: `${LEGACY_MYACCOUNT_URL}refer`,
  payments: `${LEGACY_MYACCOUNT_URL}payments`,
  makePayment: `${LEGACY_MYACCOUNT_URL}payments/new`,
  meterReadings: `${LEGACY_MYACCOUNT_URL}readings`,
  meterReadingHistory: `${LEGACY_MYACCOUNT_URL}meter-reading-history`,
  personalDetails: `${LEGACY_MYACCOUNT_URL}personal-details`,
  renewal: `${LEGACY_MYACCOUNT_URL}renew`,
  progress: `${LEGACY_MYACCOUNT_URL}progress`,
  loginError: `${LEGACY_MYACCOUNT_URL}login-error`,
  moveOutStatus: `${LEGACY_MYACCOUNT_URL}move-out/status`,

  websiteHome: `${PUBLIC_WEBSITE_URL}`,
  movingInTypeform: `${PUBLIC_WEBSITE_URL}/moving-in`,
  referFriend: `${PUBLIC_WEBSITE_URL}refer-a-friend`,
  contact: `${PUBLIC_WEBSITE_URL}contact`,
  faq: `${PUBLIC_WEBSITE_URL}faq`,
  help: `${PUBLIC_WEBSITE_URL}help`,
  directDebit: `${PUBLIC_WEBSITE_URL}direct-debit`,
  movingHome: `${PUBLIC_WEBSITE_URL}help/moving`,
  getAQuote: `${PUBLIC_WEBSITE_URL}energy/quote`,
  warmHomeDiscount: `${PUBLIC_WEBSITE_URL}warm-home-discount`,
  smartMeterBooking: `${PUBLIC_WEBSITE_URL}smart-meter-booking`,
  evChargerQuoteSurvey: `${TYPEFORM_URL}/evcharger`,
  what3Words: `${WHAT_3_WORDS_URL}`,
  ...aboutUsRouters,
  ...productRoutes,
  ...helpRoutes,
} as const

export type ExternalRoute = (typeof ExternalRoute)[keyof typeof ExternalRoute]
